const _ = require('lodash');

const initialHoaOnboardingDataState = {
    isCompleted: false,
    completedBy: "",
    completedAt: "",
    data: {}
}

const initialHoaOnboardingData:any = {
    "clientDirectory": initialHoaOnboardingDataState,
    "portalSearch": initialHoaOnboardingDataState,
    "emailHoa": initialHoaOnboardingDataState,
    "callHoa": initialHoaOnboardingDataState
};

function removeFieldsFromChangeLogState(obj: any) {
    if (obj.version != null) {
        delete obj.version;
    }

    if (obj.uploadedBy != null) {
        delete obj.uploadedBy;
    }

    if (obj.completedBy != null) {
        delete obj.completedBy;
    }
}

function modifyFieldsInChangeLogState(obj: any) {
    if (obj.violationFee != null) {
        obj.violationFee = getNegativeValueInAccountingForm(obj.violationFee);
    }

    if (obj.violationFeeOutstanding != null) {
        obj.violationFeeOutstanding = getNegativeValueInAccountingForm(obj.violationFeeOutstanding);
    }

    if (obj.dueFee != null) {
        obj.dueFee = getNegativeValueInAccountingForm(obj.dueFee);
    }

    for (let key in obj) {
		if(typeof obj[key] === 'string' && obj[key].includes('T' && 'Z')) {
			const date = new Date(obj[key]);
			if(date instanceof Date && !isNaN(date.getMonth())) {
                obj[key] = getFormattedDateFromTimestamp(obj[key])
			}
		}
	}
}

function getNegativeValueInAccountingForm(value: any) {
    if (!value) {
        return '$0';
    }

    if (value < 0) {
        return `($${value * -1})`;
    }

    return `$${value}`;
}

function iterateAndModifyFieldFromChangeLogState(state: any) {
    if (state && typeof state === 'object') {
        if (Array.isArray(state)) {
            for (const item of state) {
                iterateAndModifyFieldFromChangeLogState(item);
            }
        }
        else {
            removeFieldsFromChangeLogState(state);
            modifyFieldsInChangeLogState(state);
            Object.keys(state).forEach(key => {
                iterateAndModifyFieldFromChangeLogState(state[key]);
            });
        }
    }
}

export function getExtendedTitle(prevTitle:any, currentTitle:any) {
    return `${prevTitle ? prevTitle + '-' : ''}${currentTitle}`;
}

export function getChange (log: any) {
    const {prevState, updatedState, events, updatedAt} = log;

    if (prevState && !prevState.onboardingData) {
        prevState.onboardingData = initialHoaOnboardingData;
    }

    iterateAndModifyFieldFromChangeLogState(prevState);
    iterateAndModifyFieldFromChangeLogState(updatedState);

    let changes: any = {};

    if (_.isEmpty(prevState)) {
        const titles = Object.keys(updatedState);
        for (const title of titles) {
            if (title === 'municipality') {
                getChangesFromMunicipalityObject(updatedState[title], {}, changes);
                continue;
            }

            if (updatedState[title]) {
                changes[title] = {
                    previous: '',
                    current: updatedState[title]
                };
            }
        }
    }
    else {
        try {
            getDataFromObjects(updatedState, prevState, changes, '');
        } catch (error) {
            changes = {error: error.message};
        }
    }

    return {
        events,
        updatedAt,
        changes
    };
}

function handleBoolean(value:any) {
    if (typeof(value) != 'boolean') {
        return value || ''
    }
    else {
        return value;
    }
}

const getChangedKeys = (
	obj1: Record<string, any>, //! previous
	obj2: Record<string, any>, //! updated
	prefix = ""
): Record<string, { previous: any; current: any }> => {
	let changes: Record<string, { previous: any; current: any }> = {};

	// Get all unique keys from both objects
	const allKeys = _.union(_.keys(obj1), _.keys(obj2));

	allKeys.forEach((key: any) => {
		const fullPath = prefix ? `${prefix}-${key}` : key;

		if (!_.has(obj1, key)) {
			// Key exists in obj2 but not in obj1 (newly added)
			changes[fullPath] = { previous: undefined, current: obj2[key] };
		} else if (!_.has(obj2, key)) {
			// Key exists in obj1 but not in obj2 (removed)
			changes[fullPath] = { previous: obj1[key], current: undefined };
		} else if (_.isPlainObject(obj1[key]) && _.isPlainObject(obj2[key])) {
			// If both values are objects, recurse
			const nestedChanges = getChangedKeys(obj1[key], obj2[key], fullPath);
			Object.assign(changes, nestedChanges);
		} else if (!_.isEqual(obj1[key], obj2[key])) {
			// If values are different, add key path to result
			changes[fullPath] = { previous: obj1[key], current: obj2[key] };
		}
	});

	return changes;
};

export function getDataFromObjects (updatedState:any, prevState:any, changes:any, extendedTitle:any) {
    const files = [
        'resolutionFormUrl',
        'renewalFormUrl',
        'amenityRegulationFiles',
        'amenityPhotos',
    ];

    if(extendedTitle.includes('documents-') && prevState && Object.keys(prevState).length > 0 && updatedState && Object.keys(updatedState).length === 0) {
        const update = getChangedKeys(prevState, updatedState, extendedTitle);
        if (_.isObject(update) && !_.isEmpty(update)) {
            Object.assign(changes, update);
        }
    }

    const titles = Object.keys(updatedState || {});
    const prevTitles = Object.keys(prevState || {});
    for (const title of titles) {
        if (title === 'propertiesNumberOfHOA' || title === 'selectedCommunityService') {
            continue;
        }

        if (title === 'municipality') {
            getChangesFromMunicipalityObject(!updatedState ? {} : updatedState[title], !prevState ? {} : prevState[title], changes);
            continue;
        }

        if (typeof updatedState[title] !== 'object') {
            const isExist = prevTitles.includes(title);

            if (title === 'notificationType') {
                if (isExist && prevState[title]) {
                    prevState[title] = getFormattedHoaViolationNotification(prevState[title]);
                }

                if (updatedState[title]) {
                    updatedState[title] = getFormattedHoaViolationNotification(updatedState[title]);
                }
            }

            if (isExist) {
                if (updatedState[title] !== prevState[title]) {
                    changes[getExtendedTitle(extendedTitle, title)] = {
                        previous: handleBoolean(prevState[title]),
                        current: handleBoolean(updatedState[title])
                    };
                }
            } else if (!isExist && updatedState[title] !== '') {
                changes[getExtendedTitle(extendedTitle, title)] = {
                    previous: '',
                    current: handleBoolean(updatedState[title])
                };
            }
        }
        else if (typeof updatedState[title] === 'object' && Array.isArray(updatedState[title])) {
            const isExist = prevTitles.includes(title);
            updatedState[title] = updatedState[title].filter((value:any) => value !== null);

            if (isExist) {
                if (Array.isArray(prevState[title])) {
                    prevState[title] = prevState[title].filter((value:any) => value !== null);
                }

                const prev = prevState[title] || [];
                const curr = updatedState[title] || [];
                let isChanged = false;
                const values = prev.length > curr.length ? prev : curr;
                const checkValues = prev.length > curr.length ? curr : prev;

                if (files.includes(title)) {
                    for (const tl of values) {
                        if (checkValues.findIndex((value:any) => value.fileName === tl.fileName) === -1 || checkValues.length === 0) {
                            isChanged = true;
                            break;
                        }
                    }
                } else {
                    // for (const tl of values) {
                    //     if (checkValues.findIndex((value:any) => JSON.stringify(value) === JSON.stringify(tl)) === -1 || checkValues.length === 0) {
                    //         isChanged = true;
                    //         break;
                    //     }
                    // }
                    isChanged = !_.isEqual(prev, curr);
                }

                if (isChanged) {
                    changes[getExtendedTitle(extendedTitle, title)] = {
                        previous: prevState[title] || [],
                        current: updatedState[title] || []
                    };
                }
            } else if (!isExist && updatedState[title].length > 0) {
                changes[getExtendedTitle(extendedTitle, title)] = {
                    previous: [],
                    current: updatedState[title] || []
                };
            }
        }

        if (typeof updatedState[title] === 'object' && !Array.isArray(updatedState[title])) {
            getDataFromObjects(updatedState[title], !prevState ? prevState : prevState[title], changes, getExtendedTitle(extendedTitle, title));
        }
    }
}

export function getChangesFromMunicipalityObject(updatedState:any, prevState:any, changes:any) {
    if (_.isEmpty(prevState) && _.isEmpty(updatedState)) {
        return;
    }

    if (!_.isEmpty(updatedState)) {
        updatedState.renewalFee = updatedState.fees?.renewalFee;
    }

    if (!_.isEmpty(prevState)) {
        prevState.renewalFee = prevState.fees?.renewalFee;
    }

    let previous = {};
    let current = {};

    const requiredMunicipalityKeys = ['tenantLeaseRegistrationFormUrl', 'registrationResolutionForm', 'registrationRequirements', 'countyOrMunicipalityRenewalForm', 'ownerRenewalForm', 'renewalInstructions', 'renewalFee'];

    for (const key of requiredMunicipalityKeys) {
        if (_.isEmpty(prevState)) {
            current = {
                ...current,
                [key]: updatedState[key]
            };
        }
        else if (JSON.stringify(prevState[key]) != JSON.stringify(updatedState[key])) {
            previous = {
                ...previous,
                [key]: prevState[key]
            };

            current = {
                ...current,
                [key]: updatedState[key]
            };
        }
    }

    if (Object.keys(previous).length || Object.keys(current).length) {
        changes['municipality'] = {
            previous: previous,
            current: current
        };
    }
}

export function getFormattedHoaViolationNotification(value:any ) {
    if (!value) {
        return 'N/A';
    }

    if (value.includes('Email') && value.includes('Written Notice')) {
        return 'Written Notice, Email';
    }
    else if (value.includes('Email') || value.includes('Written Notice')) {
        return value;
    }
}

export const getFormattedDateFromTimestamp = (timestamp: string) => {
	const date = new Date(timestamp);

	let dateString;
	if (date.toString() !== 'Invalid Date') {
	// if date is valid, return formatted string
		const year = date.getFullYear();
		const month = date.getMonth()+1;
		const day = date.getDate();

		dateString = month + '/' + day + '/' + year;
	}
	else {
	// if date is not valid, return not available string
		dateString = '';
	}

	return dateString;
}

export const saveNewLogsInDatastore = (allLogs:any, datastore:any) => {
    if(Array.isArray(allLogs) && allLogs.length) {
        for(let i = 0; i < allLogs.length; i++) {
            const tmpData = allLogs[i];
            tmpData.createdAt = new Date(tmpData.createdAt).toLocaleString('en-US')
            var propertyId = tmpData.tagTypeId;
            if(datastore.createdLogs[propertyId]){
                let tempLogs = {...datastore.createdLogs[propertyId]};
                tempLogs.data = [tmpData, ...datastore.createdLogs[propertyId].data];
                tempLogs.count = datastore.createdLogs[propertyId].count + 1;
                datastore.createdLogs[propertyId] = tempLogs;
            } else {
                datastore.createdLogs[propertyId] = {};
                let tempLogs = {...datastore.createdLogs[propertyId]};
                tempLogs.data = [tmpData];
                tempLogs.pageNumber = 1;
                tempLogs.isLastPage = true;
                tempLogs.count = 1;
                datastore.createdLogs[propertyId] = tempLogs;
            }
        }
    }
}

export const getOnboardingChangeEvents = (previousOnboardingDataState:any, onboardingDataState:any) => {
    const onboardingChangeEvents:any = [];

    if (!previousOnboardingDataState || !onboardingDataState) {
        return onboardingChangeEvents;
    }

    if (JSON.stringify(previousOnboardingDataState["clientDirectory"]) != JSON.stringify(onboardingDataState["clientDirectory"])) {
        onboardingChangeEvents.push("Client Directory");
    }

    if (JSON.stringify(previousOnboardingDataState["portalSearch"]) != JSON.stringify(onboardingDataState["portalSearch"])) {
        onboardingChangeEvents.push("Portal Search");
    }

    if (JSON.stringify(previousOnboardingDataState["emailHoa"]) != JSON.stringify(onboardingDataState["emailHoa"])) {
        onboardingChangeEvents.push("Email HOA");
    }

    if (JSON.stringify(previousOnboardingDataState["callHoa"]) != JSON.stringify(onboardingDataState["callHoa"])) {
        onboardingChangeEvents.push("Call HOA");
    }

    return onboardingChangeEvents;
}

export function getType(type:string) {
    const typeMap:any = {
		hoa: "hoas",
		municipality: "municipalities",
		property: "properties",
		mail: "mails",
        email: "emails"
	};
	return typeMap[type] || "";
}